module.exports = __webpack_public_path__ + "img/69.d6a6ea5a.jpg";